<div id="hotel-result-component" class="d-flex"
     style="border-radius: 10px !important; width: auto;"
     (mouseenter)="onMouseEnter(index)"
     (mouseleave)="onMouseLeave(index)"
     [ngStyle]="{
       'border': '2px solid transparent',
       'background': getPromotions(result)
         ? 'linear-gradient(white, white) padding-box, linear-gradient(to right, ' + (stylePathPrice?.card_line || '#e0e0e0') + ', ' + (stylePathPrice?.card_line || '#e0e0e0') + ') border-box'
         : 'linear-gradient(white, white) padding-box, linear-gradient(to right, #e0e0e0 70%, #e0e0e0 77.9099%, ' + (stylePathPrice?.card_line || '#e0e0e0') + ' 77.91%, ' + (stylePathPrice?.card_line || '#e0e0e0') + ' 100%) border-box'
     }">

    <div class="d-flex flex-column" style="width: 78%;" [ngStyle]="{ 'background-color': hoverStates[index] ? stylePathPrice?.card_background_price : '#ffffff'}">
      <div class="d-flex flex-row w-100" style="position: relative; height: 100%;"
         [ngStyle]="{'margin-bottom': categoryId === 3 ? '20px' : '0'}">



       <div class="d-flex flex-column container-image"
            style=" overflow: hidden; align-items: flex-start; object-fit: contain; position: relative;"
            [ngClass]="{'px-3': (categoryId !== 1 && categoryId !== 6 && categoryId !== 9),
                        'pr-0': (categoryId === 1 || categoryId === 6 || categoryId === 9)}"
            [ngStyle]="{'height': (categoryId === 1 || categoryId === 6 || categoryId === 9) ? '100%' : 'auto',
                        'padding-top': (categoryId === 1 || categoryId === 6 || categoryId === 9) ? '0' : '2.5em'}">

                  <usb-product-media
                            style="height: 100%;width: 100%"
                            [ngStyle]="{'height': (categoryId === 1 || categoryId === 6 || categoryId === 9) ? '100%' : 'auto'}"
                            [imageUrl]="getImagePortrait(result)"
                            [logoUrl]="result?.logo"
                            [supplierLogo]="categoryId === 2 ? result?.additionalInfo?.carRental?.optionRates?.suplier?.img : ''"
                            [categoryId]="categoryId"
                            [exclusiveDeal]="categoryId === 1 ? getExclusiveDeal(result) : null"
                            [mealsData]="categoryId === 1 ? getMealsFirstRoom(result) : ''"
                            [mealsNameRoom]="categoryId === 1 ? getMealsNameRoom(result): ''"
                            [rentalCarData]="categoryId === 2 ? getRatingAcriss(result?.additionalInfo?.carRental?.acriss_extra_detail?.rating) : ''"
                            [clientsSettingAppBooking]="clientsSettingAppBooking"
                            (imageClick)="openModal(ModalRooms, 'photos')"
                ></usb-product-media>

        </div>

         <div class="d-flex flex-column container-info" style=" overflow: hidden;">

          <usb-action-buttons
                              [views]="getViews(result)"
                              [categoryId]="categoryId"
                              [videoInstitutional]="result?.video_institut ? result?.video_institut : null"
                              [videoCommercial]="result?.video_ecomerce ? result?.video_ecomerce : null"
                              [description]="result?.description"
                              (openModalEmit)="openModal(ModalRooms, 'comments')"
          >
          </usb-action-buttons>

          <div class="d-flex flex-column justify-content-between mt-2" style="height: 100%;">

            <div class="d-flex flex-column pr-3">
              <p class="poppins-regular-22pt mb-0"
                 [ngStyle]="{'min-height': categoryId === 6 || categoryId === 9 ? '54.5px' : 'auto'}"
                 tooltip="{{(categoryId !== 8 ? result?.title : result['vehicles'][0]['vehicle']['name'])}}"
                 placement="bottom"
                 style="line-height: 1.2;margin-left:1.3em">
                {{ (categoryId !== 8 ? result?.title : result['vehicles'][0]['vehicle']['name']) | truncate : 44 : '...' }}
                <span *ngIf="categoryId === 2" style="font-size: 16px">o similiar</span>
              </p>
            </div>

            <!-- SECCION INFORMACION POR CATEGORIA -->
            <ng-container *ngIf="categoryId === 1">
              <usb-hotel-result
                                class="d-flex flex-column h-100"
                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                [rate]="getStarsHotels(result)"
                                [result]="result"
                                [payload]="payload"
                                [form]="form"
                                [arrayResults]="arrayResults"
                                [form]="form"
                                [paymentAgencyActive]="paymentAgencyActive"
                                (qtyProductValidDecrement)="qtyProductValidDecrement()"
                                (modalClosedemitter)="modalClosedemitter($event)"
                                (openModalEmit)="openModal(ModalRooms, $event)"
              >
              </usb-hotel-result>
            </ng-container>

            <ng-container *ngIf="categoryId === 2">
              <usb-rent-a-car-result
                                    [result]="result"
                                    [clientsSettingAppBooking]="clientsSettingAppBooking"
              >
              </usb-rent-a-car-result>
            </ng-container>

            <ng-container *ngIf="categoryId === 6 || categoryId === 9">
              <usb-activities-result
                                    [result]="result"
                                    [clientsSettingAppBooking]="clientsSettingAppBooking"
                                    (openModalEmit)="openModal(ModalRooms, $event)"
              >
              </usb-activities-result>
            </ng-container>

            <ng-container *ngIf="categoryId === 8">
               <usb-transport-result
                                    [result]="result"
                                    [clientsSettingAppBooking]="clientsSettingAppBooking"
              >
              </usb-transport-result>

            </ng-container>
          </div>
         </div>
      </div>

      <div *ngIf="categoryId === 2" class="d-flex flex-column w-100" >
        <div class="d-flex flex-column w-100 h-75 mx-auto justify-content-center px-4 pt-2 pb-3"
              style=" border-top: .5px solid #cccccc;border-bottom:.5px solid #cccccc;">
              <p class="rubik-regular-12pt mb-1" style="font-weight: 500; color:black;">Incluye</p>
              <div *ngIf="includesRentacar && includesRentacar.length > 0" class="h-auto d-flex row ">
                  <ng-container *ngFor="let amenitie of includesRentacar;let last = last">
                    <div class="d-flex w-50 align-items-start" *ngIf="amenitie.Name" style="gap: 0.25em;">
                      <i class="bi bi-check-lg" style="line-height: 1; color: black;margin-top: -2px"></i>
                      <p  class="rubik-regular-12pt" style="margin-bottom: 2.5px">
                        {{ amenitie.Name }}
                      </p>
                    </div>
                  </ng-container>
              </div>

              <div *ngIf="includesRentacar && includesRentacar.length === 0" class="h-auto d-flex row " style="min-height: 48px">

                    <p  class="rubik-regular-12pt mb-0">
                      N/A
                    </p>
              </div>
            </div>

      <div class="d-flex flex-row w-100" style="height: 67px;">
        <!-- <div class="w-25 d-flex align-items-center justify-content-center px-1" style="width: 120px; height: 60px;">

        </div> -->

        <div class="item-info d-flex flex-row align-items-center justify-content-center px-2" style="width: 46%; height: 67px;border-right: .5px solid #cccccc; ">
            <img src="../../../../../assets/icons/search-result/kilometraje libre.svg" width="25px" height="25px" alt="" class="mr-2" style="opacity: 50%;" />
            <div class="d-flex flex-column">
                      <p class="rubik-regular-12pt mb-0">kilometraje</p>
                      <p class="rubik-regular-12pt mb-0">libre</p>
                    </div>
        </div>

        <div class="d-flex align-items-center justify-content-center pr-1 pl-3" style="width: 60%; height: 100%;">


            <img *ngIf="payload?.others?.carRental?.pickupLocation?.type === 'airport'" src="../../../../../assets/icons/search-result/AEREOPUERTO 1.svg" width="25px" height="25px" alt=""  style="opacity: 50%;" />
            <img *ngIf="payload?.others?.carRental?.pickupLocation?.type !== 'airport'" src="../../../../../assets/icons/itinerary/lugar.svg" width="34px" height="34px" alt="" style="opacity: 50%">
            <div class="ml-2" style="line-height: 12px;">
              <p class="rubik-regular-12pt mb-0">
                {{ form?.origin?.name }}
              </p>
              <p class="rubik-regular-12pt mb-0" style="margin-top: 2px; color: black">Salida desde {{payload?.others?.carRental?.pickupLocation?.type === 'airport' ? ' el aeropuerto' : 'la ciudad'}}:
                {{payload?.arrivalDate | date: 'd MMM.'}} {{payload?.others?.carRental?.pickupLocation?.pickupTime.substring(0,5)}} hs
              </p>
            </div>


        </div>
      </div>
      </div>


      <div *ngIf="categoryId === 8">
          <div class="d-flex flex-row container-info w-100 mt-auto" style="height: 67px;border-top: .5px solid #cccccc;margin-top: 35px !important;">
            <div class="item-info w-25 d-flex justify-content-center align-items-center" style=" gap: 2px;">
                <ng-container *ngIf="getLanguages(result['vehicles']) !== ''" >
                    <img src="../../../../../assets/icons/search-result/tour/idioma.svg" style="width: 22px;opacity: .5" alt="">
                      <span class="ml-1">
                          <div class="d-flex flex-column">

                              <div class="d-flex align-items-center" style="gap: 2px;">
                                  <span *ngFor="let language of getLanguangesArr(result['vehicles'])">
                                      <img src="{{getFlagByLanguageName(language)}}"
                                                [tooltip]="language"
                                                aria-hidden="true"
                                                placement="bottom"
                                          style="width: 12px; border-radius: 2px;border-radius: 2px;margin-top: 2px" alt="">
                                  </span>
                              </div>
                                 <p class="rubik-regular-12pt mb-0">Idioma</p>
                          </div>

                      </span>
                  </ng-container>

                  <ng-container *ngIf="getLanguages(result['vehicles']) === ''" >
                      <img #icon src="../../../../../assets/icons/search-result/tour/idioma.svg" style="width: 22px;opacity: .5" alt="">
                      <span class="ml-1">

                            <p class="rubik-regular-12pt mb-0">
                              N/A
                            </p>
                            <p class="rubik-regular-12pt mb-0">Idioma</p>
                      </span>
                  </ng-container>
            </div>
            <div class="item-info d-flex flex-row align-items-center justify-content-center   px-2" style="gap: .25em; width: 150px;border-right: .5px solid #cccccc;border-left: .5px solid #cccccc;">
                <img src="../../../../../assets/icons/search-result/bus.svg" width="24px" height="24px" alt="" style="opacity: .5"
                  class="icon-info">

                <div  style="line-height: 12px;">
                  <p class="rubik-regular-12pt mb-0">
                    {{ result['vehicles'].length}} opciones
                  </p>
                  <p class="rubik-regular-12pt mb-0">
                    de traslado
                  </p>
                </div>
            </div>
              <div class="item-info w-75 d-flex flex-row align-items-center px-2" style="gap: .25em">
                <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="26px" height="26px" style="opacity: .5" alt=""
                  class="icon-info" />

                <div  >
                  <p class="rubik-regular-12pt mb-0">
                    Servicio calculado para tu llegada.
                  </p>
                  <p class="rubik-regular-12pt mb-0" style="font-weight: 600;">
                    Salida desde el
                    {{typeTransferResult()}}:
                    {{payload['pickupDate'] | date : 'dd MMM.'}}
                    {{payload.transfers.pickupTime}} hs
                  </p>
                </div>
              </div>
          </div>
      </div>


    </div>

    <!-- CONTENEDOR DE PRECIO CORREGIDO -->
    <div class="d-flex flex-column justify-content-between container-price"
         style="border-top-right-radius: 6px; border-bottom-right-radius: 6px; background-color: #d8d8d8;"
         [style.border-left]="'2px solid ' + (stylePathPrice?.card_line || '#000')"
         [style.background-color]="stylePathPrice?.card_background_price || '#d8d8d8'">

      <div class="d-flex flex-column px-3 mb-2" style="margin: 0 auto; position: relative;"
      [ngStyle]="{'margin-top': categoryId === 1 &&
                                                        getPromotions(result)
                                                        ? '18px' :
                                                        categoryId !== 1 ?
                                                        '49px' :
                                                        '49px'}">

          <span *ngIf="getPromotions(result)">
              <usb-promotions
                              [promotionsApplied]="promotionsApplied"
                              [currencies]="currencies"
                              [currencyAgency]="currencyAgency"
              ></usb-promotions>
          </span>

            <usb-card-price   [ngStyle]="{'margin-top': categoryId === 1 &&
                                                        getPromotions(result)
                                                        ? '0px' :
                                                        categoryId !== 1 ?
                                                        '0px' :
                                                        '12px'}"
                              [pricesData]="pricesData"
                              [promotionsApplied]="promotionsApplied"
                              [clientsSettingAppBooking]="clientsSettingAppBooking"
                              [categoryId]="categoryId"
            ></usb-card-price>

            <usb-booking-actions
                                [cancellationPolicyData]="cancellationPolicyData"
                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                [stylePathPrice]="stylePathPrice"
                                (openModalEmit)="openModal(ModalRooms, '')"
            ></usb-booking-actions>

          </div>

          <usb-blickoins
                          [blickoins]="getBlickoins(result)"
                          [stylePathPrice]="stylePathPrice"
          ></usb-blickoins>

    </div>
</div>
